/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "368")




  export type API58842Req = {};



export interface API58842Res {
  /** 周期编号  */
  periodNo?: string;
  /** 周期名称  */
  periodName?: string;
  /** obj数量  */
  objCount?: number;
  /** kr数量  */
  krCount?: number;
  /** 总进度，例如30%返回3000  */
  progressNumber?: number;
  /** 审核状态  */
  auditStatus?: number;
  /** 审核状态-中文  */
  auditStatusStr?: string;
  /** 周期开始时间  */
  periodStartDate?: any;
  
};


// 58842 我的okr

export interface IUseGetAPI58842Return {
  /** 我的okr: 接口请求状态 */
  isAPI58842Loading: boolean;
  /** 我的okr: 接口请求返回数据 */
  dataAPI58842: API58842Res;
  /**  我的okr: 接口数据请求方法 */
  fetchAPI58842Data:  ( config?: YWRequestConfig) => Promise<API58842Res>;
  /** 我的okr: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI58842 = ():IUseGetAPI58842Return => {
  let isMount = true;
  const [isAPI58842Loading, setIsAPI58842Loading] = useState(false);
  const [dataAPI58842, setDataAPI58842] = useState<API58842Res>({} as API58842Res);
  const requestUrl = `${basePath}/internal-control-biz/mobile/okr/my`;

  const fetchAPI58842Data = async ( config?: YWRequestConfig): Promise<API58842Res> => {
  
    if ( isMount ) {
      setIsAPI58842Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API58842Res>(`${basePath}/internal-control-biz/mobile/okr/my`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI58842(res || {} as API58842Res);
        setIsAPI58842Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI58842Loading(false);
      }
      return false as unknown as API58842Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI58842Loading,
    dataAPI58842,
    fetchAPI58842Data,
    requestUrl,
  }
}

